module.exports = __webpack_public_path__ + "img/M04.dc03b0fa.png";